{
  "version": 1,
  "asset_id": "1d5b7373-a44c-45ff-9796-cdde3a62a07f",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/1d5b7373-a44c-45ff-9796-cdde3a62a07f/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/1d5b7373-a44c-45ff-9796-cdde3a62a07f/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.avif",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-480w.avif",
  "size": 7042,
  "content_type": "image/avif",
  "created_at": "2026-08-27T15:20:55Z"
}
